import React, { useState } from "react";
import ProductPageSettingTabComponent from "./productPageSettingTab.component";
import { connect, useSelector } from "react-redux";
import {
  addLanguage,
  deleteLanguage
} from "../../../redux/slice/productPage.slice";

function ProductPageSettingTabContainer({ isEditorMode, lang, addLanguage, deleteLanguage }) {
  const [showLangSelect, setShowLangSelect] = useState(false);
  const languages = useSelector(state => state.constant.languages);

  const handleShowLangSelect = () => {
    setShowLangSelect(true);
  };

  const handleAddLanguage = values => {
    addLanguage(values);
    setShowLangSelect(false);
  };

  const handleDeleteLanguage = lang => {
    deleteLanguage(lang);
  };

  return (
    <ProductPageSettingTabComponent
      handleDelete={handleDeleteLanguage}
      lang={lang}
      showLangSelect={showLangSelect}
      handleShowLangSelect={handleShowLangSelect}
      handleAddLanguage={handleAddLanguage}
      languages={languages}
      isEditorMode={isEditorMode}
    />
  );
}

const mapStateToProps = state => ({
  lang: state.productPage.lang,
  isEditorMode: state.productPage.isEditorMode,
});

const mapDispatchToProps = dispatch => ({
  addLanguage: payload => dispatch(addLanguage(payload)),
  deleteLanguage: payload => dispatch(deleteLanguage(payload))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductPageSettingTabContainer);
